var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
export function DescriptionList(_a) {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (_jsx("dl", Object.assign({}, props, { className: clsx(className, 'grid grid-cols-1 text-base/6 sm:grid-cols-[min(50%,theme(spacing.80))_auto] sm:text-sm/6') })));
}
export function DescriptionTerm(_a) {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (_jsx("dt", Object.assign({}, props, { className: clsx(className, 'col-start-1 border-t border-zinc-950/5 pt-3 text-zinc-500 first:border-none sm:border-t sm:border-zinc-950/5 sm:py-3 dark:border-white/5 dark:text-zinc-400 sm:dark:border-white/5') })));
}
export function DescriptionDetails(_a) {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (_jsx("dd", Object.assign({}, props, { className: clsx(className, 'pb-3 pt-1 text-zinc-950 sm:border-t sm:border-zinc-950/5 sm:py-3 dark:text-white dark:sm:border-white/5 sm:[&:nth-child(2)]:border-none') })));
}
